export default "__VITE_ASSET__bcd6f5b8__"